import React from 'react'
import { Outlet } from 'react-router-dom'

import './ProformaInvoicePage.less'

const ProformaInvoicePage = () => {
  return (
    <div className='proformainvoice'>
      <Outlet />
    </div>
  )
}

export default ProformaInvoicePage
